import { Paper } from "@material-ui/core";
import { CSSProperties, ReactElement } from "react";
import styles from "./RxPaper.module.css";

interface RxPaperProps {
	doNotUseDefaultStyle?: boolean;
	style?: CSSProperties;
	className?: string;
	children: ReactElement;
	elevation?: number;
}

const RxPaper = (props: RxPaperProps) => {
	const useDefault = !props.doNotUseDefaultStyle ?? true;
	return (
		<Paper
			elevation={props.elevation ?? 5}
			style={props.style}
			className={
				(useDefault ? styles.defaultPaperCss : "") + " " + props.className
			}
		>
			{props.children}
		</Paper>
	);
};

export default RxPaper;
